<template>
  <div
    class="label-description-box"
    :class="{'disabledLabel': disabled}"
  >
    <!-- 所有标签 -->
    <div v-show="!disabled" class="label-list" :class="{'is-disabled': disabled}">
      <span
        v-if="showUrgentLabel"
        class="label-item"
        :class="{'is-selected': urgentOrderFlag === 1}"
        @click="handelUrgent"
      > #加急派送 </span>
      <span
        v-for="item in list"
        class="label-item"
        :class="{'is-selected': Array.isArray(labelList) && labelList.includes(item.scene)}"
        :key="item.id"
        :id="item.id"
        @click="handleClick(item)"
      >{{ item.scene }}</span>
    </div>
    <div class="description-input">
      <el-input
        :value="problemDescription"
        type="textarea"
        show-word-limit
        placeholder="请输入"
        :maxlength="maxlength"
        :disabled="disabled"
        :rows="4"
        @focus="textareaFocus"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelDescription',
  props: {
    isRequired: {
      type: Boolean,
      default: false
    },
    // 总数
    maxlength: {
      type: Number,
      default: 500
    },
    // 标签列表
    list: {
      type: Array,
      default: () => []
    },
    // 是否支持重复选择
    isRepeat: {
      type: Boolean,
      default: false
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    showUrgentLabel: {
      type: Boolean,
      default: false
    },
    urgentOrderFlag: {
      type: Number,
      default: 2
    },
    isNotInsert: {
      type: Boolean,
      default: false
    },
    labelList: {
      type: Array,
      default: () => []
    },
    problemDescription: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    isMultiple() {
      return this.list && this.list[0] && this.list[0].multipleChoice === 1;
    }
  },
  mounted() {},
  methods: {
    handelUrgent(e) {
      this.$emit('update:urgentOrderFlag', this.urgentOrderFlag === 1 ? 2 : 1)
    },
    handleClick(item = {}) {
      if (this.disabled) return
      let labelList = []
      if (Array.isArray(this.labelList) && this.labelList.includes(item.scene)) {
        labelList = this.labelList.filter(label => label !== item.scene);
      } else {
        labelList = this.isMultiple ? [...(this.labelList || []), item.scene] : [item.scene]

        if (!this.isNotInsert) {
          this.$emit('update:problemDescription', (this.problemDescription || '') + (item.fastWord || ''))
        }
      }
      this.$emit('update:labelList', labelList);
    },
    onInput(val) {
      console.log('val: ', val)
      this.$emit('update:problemDescription', val)
    },
    textareaFocus() {
      this.$emit('textareaFocus', new Date().getTime())
    }
  }
};
</script>

<style lang="scss" scoped>
.label-description-box {
  .label-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 4px;
    &.is-disabled {
      opacity: 0.5;
      .label-item {
        cursor: not-allowed;
      }
    }
    .label-item {
      color: #b4b4b2;
      padding: 0 5px;
      display: inline-block;
      border:1px solid #b4b4b2;
      border-radius: 4px;
      margin-right: 5px;
      font-size: 12px;
      cursor: pointer;
      &.is-selected {
        color: #E42E35;
        border-color: #E42E35;
      }
    }
  }
  .description-input {}
}
</style>
